import firebase from "firebase/compat/app";
import "firebase/compat/auth";
//import 'firebase/auth';
//import 'firebase/database';
//import 'firebase/firestore';
import 'firebase/compat/functions';

export async function zzzTestFunction(data: string): Promise<{ data: string }> {
    firebase.functions().useEmulator("localhost", 5001);

    const fnData = { data: data };
    const zzz = firebase.functions().httpsCallable("zzz");
    const result: { data: string } = await zzz(fnData);
    return result;
}

